import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import AddCircleOutlineRounded from '@mui/icons-material/AddCircleOutlineRounded';
import SearchIcon from '@mui/icons-material/Search';

const MarketplaceUpcScan = ({
  t,
  variant,
  className,
  value,
  disabled,
  busy,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  onSubmit,
  loading,
  enabled,
}) => {
  const upcEnabled = !loading && enabled && !disabled && !busy;
  const upcValue = (value || '').trim();

  if (variant === 'outlined') {
    return (
      <TextField
        id="marketplace-upc-scan"
        variant="outlined"
        className={className}
        placeholder={t('Assign.ScanNonRxUpc', {
          defaultValue: 'Scan or enter Marketplace UPC',
        })}
        value={value || ''}
        onChange={onChange}
        onKeyDown={onKeyDown}
        disabled={!upcEnabled}
        helperText={
          loading
            ? t('Assign.ScanNonRxUpcLoading', {
                defaultValue: 'Checking Marketplace availability…',
              })
            : enabled
              ? t('Assign.ScanNonRxUpcHint', {
                  defaultValue:
                    'Type or scan a UPC, then press Enter to add it to the cart.',
                })
              : t('Assign.ScanNonRxUpcUnavailable', {
                  defaultValue: 'Marketplace is not available yet.',
                })
        }
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                sx={{
                  color: upcEnabled ? '#0d9488' : '#b0bec5',
                  fontSize: 24,
                }}
              />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                edge="end"
                aria-label={t('Assign.ScanNonRxUpcAdd', {
                  defaultValue: 'Add Marketplace item',
                })}
                onMouseDown={(event) => {
                  event.preventDefault();
                }}
                onClick={onSubmit}
                disabled={!upcEnabled || !upcValue}
              >
                <AddCircleOutlineRounded fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            backgroundColor: '#ffffff',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#99f6e4',
              borderWidth: 2,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#0d9488',
            },
            '&.Mui-focused': {
              boxShadow: '0 0 0 3px rgba(13, 148, 136, 0.12)',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#0d9488',
                borderWidth: 2,
              },
            },
          },
        }}
      />
    );
  }

  return (
    <TextField
      id="marketplace-upc-scan"
      type="text"
      className={className}
      value={value || ''}
      margin="normal"
      variant="standard"
      label={t('Assign.ScanNonRxUpc', {
        defaultValue: 'Scan or enter Marketplace UPC',
      })}
      helperText={
        loading
          ? t('Assign.ScanNonRxUpcLoading', {
              defaultValue: 'Checking Marketplace availability…',
            })
          : enabled
            ? t('Assign.ScanNonRxUpcHint', {
                defaultValue:
                  'Type or scan a UPC, then press Enter to add it to the cart.',
              })
            : t('Assign.ScanNonRxUpcUnavailable', {
                defaultValue: 'Marketplace is not available yet.',
              })
      }
      InputLabelProps={{ shrink: true }}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      disabled={!upcEnabled}
      style={{ width: '100%' }}
      componentsProps={{
        input: {
          id: 'marketplace-upc-scan-input',
          autoComplete: 'off',
          inputMode: 'numeric',
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" className="assign-upc-scan-adornment">
            <IconButton
              className="assign-upc-scan-add"
              size="small"
              aria-label={t('Assign.ScanNonRxUpcAdd', {
                defaultValue: 'Add Marketplace item',
              })}
              onMouseDown={(event) => {
                event.preventDefault();
              }}
              onClick={onSubmit}
              disabled={!upcEnabled || !upcValue}
            >
              <AddCircleOutlineRounded fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

MarketplaceUpcScan.propTypes = {
  t: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['standard', 'outlined']),
  className: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  busy: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  enabled: PropTypes.bool,
};

MarketplaceUpcScan.defaultProps = {
  variant: 'standard',
  className: '',
  value: '',
  disabled: false,
  busy: false,
  onChange: undefined,
  onKeyDown: undefined,
  onSubmit: undefined,
  loading: false,
  enabled: true,
};

export default MarketplaceUpcScan;



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/MarketplaceUpcScan.jsx